module.exports = __webpack_public_path__ + "img/cat.a6620266.png";